import { Component, OnInit, inject, signal } from '@angular/core';

import { StoreService } from '../core/store.service';
import { PictureService } from '../core/picture.service';
import { CarouselComponent } from '../layout/carousel.component';

@Component({
    selector: 'app-slider',
    template: `
        <div class="slider-wrapper">
            <!-- <img class="home-logo" src="/assets/images/logo-transparent-white.png" /> -->
            <app-carousel [images]="homeSliderPhotos()" [indicators]="false" [autoSlide]="true" />
        </div>
    `,
    styles: ``,
    imports: [CarouselComponent]
})
export class SliderComponent implements OnInit {
    storeService = inject(StoreService);
    pictureService = inject(PictureService);
    homeSliderPhotos = signal<any[]>([]);

    ngOnInit() {
        const sliderPhotos = this.storeService.webPhotos().homeSliderPhotos.map((p) => {
            return { imageSrc: this.getSliderUrl(p.filePath), imageAlt: p.filePath, linkUrl: p.linkUrl };
        });
        this.homeSliderPhotos.set(sliderPhotos);
    }

    getSliderUrl = (fileName: string) => {
        return this.pictureService.getImageUrl('webPhoto', fileName);
    };
}
